<template v-if="product" >
  <div class="item" @click="showModal">
    <div
        v-lazy:background-image="getProductImage(product)"
        class="item-img"
        :style="imageRatioStyle"
    />
    <div class="item-title d-flex align-items-center justify-content-between">
      <h4 class="mb-0"   :class="isSushi && ' montserrat-500' ">{{ category.Name }}</h4>
      <span  :class="isSushi && ' montserrat-500' ">{{ category.Price | formatMoney(currencySign) }}</span>
    </div>
    <ul class="diet-list">
      <li
          class="diet-icon"
          :class="isSushi && ' montserrat-500' "
          v-for="(dietary, index) in dietaryList"
          :key="index"
          :style="getIconStyle(dietary)"
          :title="dietary.Name"
      ></li>
    </ul>
  </div>
</template>

<script>
import shared from "../../../sharedscripts/shop/products/Product.js";
import { DetectMobile } from "./../../../mixins/detectmobile";

export default {
  name: "Product",
  components: {},
  filters: {
    ...shared.filters,
  },
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    category: {
      type: Object,
      default: () => {},
    },
    parentCategory: {
      type: Object,
      default: () => {},
    },
    modifiers: {
      type: Object,
      default: () => {},
    },
    sectionId: {
      type: Number,
      default: 0,
    },
    isSushi : {
      type:Boolean
    }
  },
  data() {
    return {
      isModalVisible: false,
      width: 0,
      height: 0,
    };
  },
  computed: {
    ...shared.computed,
  },
  mounted() {
    this.getImageWidthHeight();
  },
  methods: {
    ...shared.methods,
    showModal() {
      if (
          DetectMobile.methods.isMobile(true) &&
          this.$root &&
          this.$root.$refs &&
          this.$root.$refs.Productlist &&
          this.$root.$refs.Productlist.$refs &&
          this.$root.$refs.Productlist.$refs.scrollview
      ) {
        this.$root.$refs.Productlist.$refs.scrollview.style.position = "";
      }
      this.isModalVisible = this.product.Status != 3;
      this.$emit(
          "showAddToCart",
          this.product.Status != 3 ? this.category : null
      );
    },
    imgHttpError(event) {
      if (event && event.target && event.target.style)
        event.target.style.display = "none";
    },
    formatStatus(value, vueObj) {
      let that = vueObj;
      let pricing;
      switch (value) {
        case 1:
          pricing = that.$t("message.new");
          break;
        case 2:
          pricing = that.$t("message.popular");
          break;
        case 3:
          pricing = that.$t("message.soldOut");
          break;
        default:
          pricing = "";
          break;
      }
      return pricing;
    },
    getProductImage(product) {
      if (product.PhotoUrl) return product.PhotoUrl;
      else return null;
    },
  },
};
</script>

<style scoped>
.item {
  display: flex;
  flex-direction: column;
  padding: 10px 25px;
  margin-bottom: 10px;
  margin-right: 10px;
  cursor: pointer;
  height: 100%;
  border-bottom: 1px solid #8080802a;
}
.diet-list {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
}
.diet-icon {
  width: 20px;
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: 5px;
}
.item-img {
  background-size: cover;
  flex-grow: 1;
  background-position: center;
  margin-bottom: 10px;
}
</style>
